import * as _4 from 'lodash4';
angular
  .module('capability-ng-scheduler')
  .directive('positionRegistrationAlerts', function positionRegistrationAlerts($document: any, $window: any) {
    'use strict';
    return {
      link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
        const body = $document.find('body');
        const headerHeight = 120;
        const debounceTime = 100;

        // using throttle here instead of bounce -- https://css-tricks.com/the-difference-between-throttling-and-debouncing/
        angular.element($window).on('scroll', _4.throttle(toggleScrollClass, debounceTime));

        function toggleScrollClass() {
          const scrollPstn = body.scrollTop();
          if (scrollPstn > headerHeight) {
            body.addClass('page-scroll-adjust-notifications');
          } else {
            body.removeClass('page-scroll-adjust-notifications');
          }
        }

        scope.$on('$destroy', () => {
          angular.element($window).off('scroll', _4.throttle(toggleScrollClass, debounceTime));
        });
      }
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/utilities/position_registration_alert.ts